export enum WalkthroughType {
  AddPatient = 'ADD_PATIENT',
  PatientList = 'PATIENT_LIST',
  CptCodes = 'CPT_CODES',
  PatientHealthTab = 'PATIENT_HEALTH_TAB',
  SelfCarePlan = 'SELF_CARE_PLAN',
  GenerateAssignment = 'GENERATE_ASSIGNMENT',
  AIEditorFirstStep = 'AI_EDITOR_FIRST_STEP',
  AIEditor = 'AI_EDITOR',
  checkClientProgress = 'CHECK_CLIENT_PROGRESS',
  referralProgram = 'REFERRAL_PROGRAM',
}
export interface IWalkthrough {
  type: WalkthroughType
  customOnNexClick?: Array<() => void>
}
